import deburr from "lodash/deburr";
import template from "./settings-signature.html";

const SettingsSignatureComponent = {
  template: template,
  controller: class SettingsSignatureController {
    /* @ngInject */
    constructor($rootScope, $state, $filter, Organization, User, OrganizationService, FilePicker, Notification) {
      this.Organization = Organization;
      this.$state = $state;
      this.$rootScope = $rootScope;
      this.$filter = $filter;
      this.User = User;
      this.OrganizationService = OrganizationService;
      this.FilePicker = FilePicker;
      this.NotificationService = Notification;
    }

    async $onInit() {
      this.organization = new this.Organization(this.$rootScope.organization);
      this.team = await this.User.getTeam();
      this.saving = false;
    }

    searchTeamMembers(searchText) {
      const normalizedSearchText = deburr(searchText).toLowerCase();
      return this.team.filter((teamMember) => {
        return deburr(teamMember.displayName).toLowerCase().includes(normalizedSearchText);
      });
    }

    setContactAsPerson(userDisplayName) {
      this.organization.settings.signature.person = userDisplayName;
    }

    async setSignatureDefault() {
      this.organization.settings.signatureDefault = !this.organization.settings.signatureDefault;
      this.OrganizationService.updateOrganization(this.organization).then((organization) => {
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")("notificationService.message.setSignatureDefault"),
        });
        this.organization = new this.Organization(this.$rootScope.organization);
        this.$state.reload();
      });
    }

    async uploadSignature() {
      if (this.form.$valid) {
        const metadata = await this.FilePicker.uploadOrganizationSignature();
        this.saving = true;
        this.organization.settings.signature.metadata = metadata;
        const organization = await this.OrganizationService.updateOrganization(this.organization);
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")("notificationService.message.setSignature"),
        });
        this.organization = new this.Organization(organization);
        this.saving = false;
        this.$state.reload();
        this.$rootScope.$applyAsync();
      }
    }
  },
};

export default SettingsSignatureComponent;
